export default __webpack_public_path__ + "static/media/hub_register-button.6fe8b661.svg";